
<mat-card class="menupannel">
    <div class="resUser">
      
    </div>
    <div class="d">
      <button mat-flat-button (click)="showDocDetail()">
        <mat-icon>keyboard_arrow_left</mat-icon> Details
      </button>
    </div>
  </mat-card>
  
  <div class="coreholder" fxLayout="row">   
  
    <!-- Core page Structure -->
    <div class="corepages">  
      <router-outlet></router-outlet>  
    </div>
    <!-- Core page Structure -->

     <!-- Filter -->
    <mat-card class="documentDetail">
      <!-- <div class="docDetail">
        <app-notification-filter></app-notification-filter>
      </div> -->
    </mat-card>
  
      <!-- Filter -->
  
    
        
  
  </div>
  